<div class="ai-agent-access-settings">
  @if (statusBlock(); as block) {
    <div class="ai-agent-access-settings__status" [class]="'ai-agent-access-settings__status--' + block.modifier">
      <span class="ai-agent-access-settings__status-icon">
        <sim-icon [icon]="block.icon" [sizeInPx]="18" />
      </span>
      <div class="ai-agent-access-settings__status-texts">
        <span class="ai-agent-access-settings__status-title">{{ block.title }}</span>
        <span class="ai-agent-access-settings__status-description">{{ block.description }}</span>
      </div>
    </div>
  }

  <section class="ai-agent-access-settings__section">
    <div class="ai-agent-access-settings__section-header">
      <h2 class="ai-agent-access-settings__heading" i18n="@@AI_AGENT_TOKENS">Tokens</h2>
      <button
        type="button"
        id="ai-agent-panel-refresh"
        class="ai-agent-access-settings__refresh"
        [disabled]="loading()"
        (click)="onRefresh()"
      >
        <sim-icon icon="refresh" [sizeInPx]="14" />
        <ng-container i18n="@@AI_AGENT_REFRESH">Refresh</ng-container>
      </button>
    </div>

    @if (status()) {
      <div class="ai-agent-access-settings__total">
        <span class="ai-agent-access-settings__total-value">{{ totalLeft() }}</span>
        <span class="ai-agent-access-settings__total-label" i18n="@@AI_AGENT_TOKENS_LEFT_TOTAL"
          >tokens left in total</span
        >
      </div>

      @for (pool of pools(); track pool.modifier) {
        <div class="ai-agent-access-settings__pool">
          <div class="ai-agent-access-settings__pool-header">
            <span class="ai-agent-access-settings__pool-label">{{ pool.label }}</span>
            @if (pool.note) {
              <span class="ai-agent-access-settings__pool-note">{{ pool.note }}</span>
            }
          </div>
          @if (pool.percentLeft !== null) {
            <div class="ai-agent-access-settings__bar" role="img" [attr.aria-label]="pool.label + ': ' + pool.left">
              <div
                class="ai-agent-access-settings__bar-fill"
                [class]="'ai-agent-access-settings__bar-fill--' + pool.modifier"
                [style.width.%]="pool.percentLeft"
              ></div>
            </div>
          }
          <div class="ai-agent-access-settings__pool-footer">
            <span>{{ pool.left }}</span>
            <span>{{ pool.aside }}</span>
          </div>
        </div>
      }

      <p class="ai-agent-access-settings__hint" i18n="@@AI_AGENT_TOKENS_EXPLAINED">
        Tokens measure how much text the assistant reads and writes. Long conversations use more — starting a new chat
        for a new topic keeps usage low.
      </p>
      @if (checkedAt(); as checked) {
        <p class="ai-agent-access-settings__checked">
          <ng-container i18n="@@AI_AGENT_LAST_CHECKED">Last checked</ng-container> {{ checked | date: 'shortTime' }}
        </p>
      }
    } @else {
      <div class="ai-agent-access-settings__loading">
        <sim-spinner [diameter]="32" [strokeWidth]="3" />
      </div>
    }
  </section>

  <section class="ai-agent-access-settings__section ai-agent-access-settings__section--contact">
    <h2 class="ai-agent-access-settings__heading" i18n="@@AI_AGENT_NEED_MORE">Need more tokens or access?</h2>
    <p class="ai-agent-access-settings__text" i18n="@@AI_AGENT_NEED_MORE_TEXT">
      Access and token packages are managed by Simlab. Send us an email and we'll sort it out.
    </p>
    <a class="ai-agent-access-settings__mail" [href]="mailto()">
      <sim-icon icon="mail" [sizeInPx]="16" />
      {{ contactEmail() }}
    </a>
  </section>
</div>
